import { createFileRoute } from "@tanstack/react-router";

import ReferralPage from "./-components/ReferralPage";

export const Route = createFileRoute("/_app/_dashboard/earn/referral")({
  component: ReferralPage,
});
